import url from '../url'
import headers from '../headers'

export default {
	get (context, user_uid, watch_id, can_abort = false) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/profile/`,
			{
				...headers.bearer(),
				before(request) {
					if (can_abort) {
						// abort previous request, if exists
						if (this.previousRequest) {
							this.previousRequest.abort();
						}
						// set previous request on Vue instance
						this.previousRequest = request;
					}
				}
			}
		)
	},
	edit (context, user_uid, watch_id, profile) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/profile/`,
			profile,
			headers.bearer()
		)
	},
	// Contacts
	contacts: {
		get (context, user_uid, watch_id, contact_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/contacts/${contact_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, watch_id, contact) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/contacts/`,
				contact,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, contact) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/contacts/${contact.id}/`,
				contact,
				headers.bearer()
			)
		},
		delete (context, user_uid, watch_id, contact_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/contacts/${contact_id}/`,
				headers.bearer()
			)
		}
	},
	// Relations
	relations: {
		get (context, user_uid, watch_id, relation_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/${relation_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, watch_id, relation) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/`,
				relation,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, relation) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/${relation.id}/`,
				relation,
				headers.bearer()
			)
		},
		delete (context, user_uid, watch_id, relation_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/${relation_id}/`,
				headers.bearer()
			)
		},
		// Relation Contacts
		contacts: {
			get (context, user_uid, watch_id, relation_id, contact_id) {
				return context.$http.get(
					`${url}/users/${user_uid}/watches/${watch_id}/profile/contacts/${contact_id}/`,
					headers.bearer()
				)
			},
			add (context, user_uid, watch_id, relation_id, contact) {
				return context.$http.post(
					`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/${relation_id}/contacts/`,
					contact,
					headers.bearer()
				)
			},
			edit (context, user_uid, watch_id, relation_id, contact) {
				return context.$http.put(
					`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/${relation_id}/contacts/${contact.id}/`,
					contact,
					headers.bearer()
				)
			},
			delete (context, user_uid, watch_id, relation_id, contact_id) {
				return context.$http.delete(
					`${url}/users/${user_uid}/watches/${watch_id}/profile/relations/${relation_id}/contacts/${contact_id}/`,
					headers.bearer()
				)
			}
		}
	},
	// Social Security Numbers
	ssnumbers: {
		getNames (context, offset = 0, size = 999) {
			return context.$http.get(
				`${url}/ssnumbers/?offset=${offset}&size=${size}`,
				headers.bearer()
			)
		},
		get (context, user_uid, watch_id, ssnumber_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/ssnumbers/${ssnumber_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, watch_id, ssnumber) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/ssnumbers/`,
				ssnumber,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, ssnumber) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/ssnumbers/${ssnumber.id}/`,
				ssnumber,
				headers.bearer()
			)
		},
		delete (context, user_uid, watch_id, ssnumber_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/ssnumbers/${ssnumber_id}/`,
				headers.bearer()
			)
		},
		admin: {
			getAll (context, offset = 0, size = 999) {
				return context.$http.get(
					`${url}/ssnumbers/?offset=${offset}&size=${size}`,
					headers.bearer()
				)
			}
		}
	},
	// Insurances
	insurances: {
		get (context, user_uid, watch_id, insurance_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/insurances/${insurance_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, watch_id, insurance) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/insurances/`,
				insurance,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, insurance) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/insurances/${insurance.id}/`,
				insurance,
				headers.bearer()
			)
		},
		delete (context, user_uid, watch_id, insurance_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/insurances/${insurance_id}/`,
				headers.bearer()
			)
		}
	},
	// Diseases
	diseases: {
		getNames (context, offset = 0, size = 999) {
			return context.$http.get(
				`${url}/diseases/?offset=${offset}&size=${size}`,
				headers.bearer()
			)
		},
		get (context, user_uid, watch_id, disease_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/diseases/${disease_id}/`,
				headers.bearer()
			)
		},
		add (context, user_uid, watch_id, disease) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/diseases/`,
				disease,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, disease) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/diseases/${disease.id}/`,
				disease,
				headers.bearer()
			)
		},
		delete (context, user_uid, watch_id, disease_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/watches/${watch_id}/profile/diseases/${disease_id}/`,
				headers.bearer()
			)
		},
		admin: {
			getAll (context, offset = 0, size = 999) {
				return context.$http.get(
					`${url}/diseases/?offset=${offset}&size=${size}`,
					headers.bearer()
				)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/profile.js